<template>
  <div
    class="validation-requirement__container"
  >
    <div
      :class="`validation-indicator_${stringState}`"
    />
    <div
      :class="`validation-requirement__text_${stringState}`"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ValidationRequirement',
  props: {
    text: {
      type: String,
      default: undefined,
    },
    state: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    stringState () {
      if (this.state) {
        return 'valid'
      } else if (!this.state) {
        return 'invalid'
      } else {
        return 'unset'
      }
    },
  },
}
</script>

<style scoped>
.validation-requirement__container {
  border-radius: 0.35rem;
  padding: 0.35rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #EFF2F7;
  margin: 0.25rem 0;
}

.validation-requirement__text_valid,
.validation-requirement__text_invalid,
.validation-requirement__text_unset {
  padding-left: 0.35rem;
}

.validation-indicator_valid,
.validation-indicator_invalid,
.validation-indicator_unset {
  border-radius: 50%;
  display: inline-block;
  height: 0.85rem;
  width: 0.85rem;
  flex-shrink: 0;
  flex-grow: 0;
}

.validation-indicator_valid {
  background-color: #ABD57C;
}

.validation-indicator_invalid {
  background-color: #D0021B;
}

.validation-indicator_unset {
  background-color: #F6AA88;
}

</style>
